<template>
  <div id="listPage">
    <div all-buttons class="all-buttons">
      <el-date-picker
        v-model="yearInput"
        type="year"
        placeholder="选择年"
        value-format="yyyy"
        size="mini"
      ></el-date-picker>
      <el-button
        type="success"
        style="background-color: #409eff; border-color: #409eff; color: #fff"
        size="mini"
        icon="el-icon-download"
        @click="exportExcel()"
        :loading="loadings.exportLoading"
        v-if="IsHasShowBtn('learners_export')"
        >导出</el-button
      >
      <el-button
        type="success"
        style="background-color: #409eff; border-color: #409eff; color: #fff"
        size="mini"
        icon="el-icon-upload2"
        :loading="loadings.importLoading"
        @click="showInputUsers('0')"
        v-if="IsHasShowBtn('learners_export')"
        >批量导入</el-button
      >
      <!-- v-if="IsHasShowBtn('learners_import')" -->
    </div>
    <el-dialog 
      title="导入节假日" 
      :visible.sync="showImportDialog"
      class="dialog"
    >
      <el-form size="mini" import-dialog>
        <el-form-item v-if="tag == '0'">
          <el-upload
            style="display: inline-block"
            :action="hostUrl + '/api/User/ImportWrokDays'"
            :show-file-list="false"
            :on-success="importTempSuccess"
            :before-upload="beforeUpload"
            :headers="uploadHeaders"
          >
            <el-button icon="el-icon-upload2" :loading="loadingUp"
              >选择文件</el-button
            >
          </el-upload>

          <el-button
            size="mini"
            icon="el-icon-download"
            @click="exportUsersTemp"
            plain
            >下载模板</el-button
          >
          <el-button
            size="mini"
            icon="el-icon-download"
            :loading="loadings.exportErrLoading"
            @click="exportUsersMsg()"
            v-if="ImportErrorCnt > 0"
            >错误信息</el-button
          >
        </el-form-item>

        <el-form-item>
          <el-input
            placeholder="导入结果"
            type="textarea"
            :rows="10"
            v-model="importResult"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBaseUrl,
  // exportUsers,
  // 批量导出节假日
  ExportWrokDays,
  // 下载导入节假日错误信息
  DownLoadWrokDaysInErrFiles,
} from "../../api/api";
import libs from "../../utils/libs";
import store from "../../utils/storage";
export default {
  data() {
    return {
      // 年
      yearInput: "",
      hostUrl: getBaseUrl(),
      isp: "",
      loadings: {
        loading: false,
        exportLoading: false,
        importLoading: false,
        exportErrLoading: false,
      },
      loading: false,
      loadingUp: false,
      tloadingUp: false,
      importResult: "",
      ImportErrorCnt: 0,
      tImportErrorCnt: 0,
      ImportErrorBatchId: "",
      tImportErrorBatchId: "",
      showDialog: false,
      showImportDialog: false,
      uploadHeaders: { "Jwt-Token": store.getToken() },
      curUser: store.getUserInfo(),
      tag: "",
      queryParams: {},
    };
  },
  //生命周期 最后一步
  destroyed() {
    // 暂存数据到浏览器
    this.queryParams.yearInput = this.yearInput;
    this.$store.commit("addTagList", this.queryParams);
  },
  created() {
    // 获取搜索信息
    this.queryParams.router = this.$route.path;
    if (this.$route.query.tags && this.$route.query.tags.list) {
      this.queryParams = this.$route.query.tags.list;
      this.yearInput = this.queryParams.yearInput;
    }
  },
  mounted() {},
  methods: {
    IsHasShowBtn(tp) {
      var curPermission = store.getPagePermission("learners");
      var exists = curPermission.filter((p) => p.VUrl == tp);
      return exists.length > 0;
    },
    // 导出信息
    exportExcel() {
      // 批量导出节假日
      var year = this.yearInput;
      ExportWrokDays({ year }).then((res) => {
        var temp_url = this.hostUrl + res.data.Data;
        window.open(temp_url);
      });
    },

    // exportUsersMsg() {
    //   this.loadings.exportErrLoading = true;
    //   DownLoadWrokDaysInErrFiles(this.ImportErrorBatchId).then(res => {
    //     var filename = "Users_ImportError";
    //     var sheetName = "节假日错误信息";

    //     var temp_url = this.hostUrl + res.data.Data;
    //     window.open(temp_url);
    //   });
    // },

    showInputUsers(num) {
      this.tag = num;
      this.showImportDialog = true;
    },

    // 批量导入模版 ------------------------------
    exportUsersTemp() {
      var temp_url = this.hostUrl + "/TempFiles/节假日维护模板.xlsx";
      window.open(temp_url);
    },
    beforeUpload(file) {
      this.loadingUp = true;
      this.importResult = "";
    },
    importTempSuccess(response, file, fileList) {
      if (response.Code != 1) {
        this.importResult = response.Message;
        this.loadingUp = false;
        return;
      }
      this.importResult = response.Data.Errmsg;
      this.ImportErrorCnt = response.Data.ErrCnt;
      this.ImportErrorBatchId = response.Data.BatchId;
      this.$message.success("导入成功");
      this.loadingUp = false;
    },
    tbeforeUpload(file) {
      this.tloadingUp = true;
      this.importResult = "";
    },

    timportTempSuccess(response, file, fileList) {
      if (response.Code != 1) {
        this.importResult = response.Message;
        this.tloadingUp = false;
        return;
      }

      this.importResult = response.Data.Errmsg;
      this.tImportErrorCnt = response.Data.ErrCnt;
      this.tImportErrorBatchId = response.Data.BatchId;

      this.$message.success("导入成功");
      this.tloadingUp = false;
    },
  },
};
</script>

<style scoped lang="less">
@import "../../assets/css/list.css";
[import-dialog] {
  padding: 0px 20px 10px;
}

.all-buttons {
  background-color: #f8f8f8;
}
.dialog {
  /deep/.el-dialog {
    min-width: 400px; 
  }
}
</style>


// WEBPACK FOOTER //
// src/components/configCenter/workdayconfig.vue